import React from 'react';
import PropTypes from 'prop-types';

// Rotated, truncated X-axis tick for category bar charts. Long names such as
// "Connector Connect / Direct" previously overlapped each other and ran outside the card.
// The untruncated name stays available via the SVG <title> tooltip and the chart Tooltip.

export const MAX_TICK_CHARS = 16;

export const truncateTickLabel = (label, maxChars = MAX_TICK_CHARS) => {
  const text = String(label === undefined || label === null ? '' : label);
  return text.length > maxChars ? `${text.slice(0, maxChars - 1).trimEnd()}…` : text;
};

const CategoryAxisTick = ({ x, y, payload, fontSize, angle }) => {
  const label = String(payload && payload.value !== undefined ? payload.value : '');
  return (
    <g transform={`translate(${x},${y})`}>
      <title>{label}</title>
      <text
        x={0}
        y={0}
        dy={10}
        textAnchor="end"
        transform={`rotate(${angle})`}
        fontSize={fontSize}
        fill="#666666"
      >
        {truncateTickLabel(label)}
      </text>
    </g>
  );
};

CategoryAxisTick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  payload: PropTypes.shape({ value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) }),
  fontSize: PropTypes.number,
  angle: PropTypes.number
};

CategoryAxisTick.defaultProps = {
  x: 0,
  y: 0,
  payload: null,
  fontSize: 11,
  angle: -35
};

export default CategoryAxisTick;
